module.exports = __webpack_public_path__ + "img/call_number.6552f95a.png";